import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { isDropWellCompare } from 'utils/Global';

import './ScoresPanel.scss';
import MarcoScore from './MarcoScore/MarcoScore';
import DefaultScores from './DefaultScores/DefaultScores';
import { IStyle } from 'Styles';
import RMTabs from 'components/customComponents/Controls/RMTabs';
import { ITabItem } from 'components/tab';
import { DisputedScoresIds } from 'business/models/Models';
import { markDisputedScores } from 'redux/reducers/experimentDataReducer';
import {
  useScoresForWells,
  useAllWellNavigationDetails,
  useSelectedDropImageParameters,
} from 'redux/hooks/experiment';
import { useApplyScoring } from 'components/Experiment/hooks';
import { useRMSelector } from 'redux/hooks';
import { selectScoresOptionsList } from 'redux/selectors/ExperimentStateSelector';

function ScoresPanel() {
  const dispatch = useDispatch();
  const isDropWellCompareMode = isDropWellCompare();
  const allWellNavigationDetails = useAllWellNavigationDetails();

  const selectedDropImageParameters = useSelectedDropImageParameters();
  const lastSelectedWell =
    allWellNavigationDetails?.[allWellNavigationDetails?.length - 1];
  const { inspection, dropNumber, cpId } = selectedDropImageParameters || {};

  const selectedWellDetails = isDropWellCompareMode
    ? [allWellNavigationDetails[allWellNavigationDetails.length - 1]]
    : allWellNavigationDetails;
  const imageBatchId = inspection?.groupedInspections?.find(
    (grp) => grp.plateId === selectedWellDetails?.[0]?.plateID,
  )?.imageBatchId;
  const scoresOfSelectedWells = useScoresForWells(
    selectedWellDetails.map((w) => ({
      wellNumber: w.wellNum,
      plateId: w.plateID,
      dropNumber: dropNumber,
    })),
  );
  const applyScoring = useApplyScoring();
  const allScoresOptionsList = useRMSelector(selectScoresOptionsList);

  const handleOnMarkDisputedScore = (disputedScoresIds: DisputedScoresIds[]) => {
    dispatch(
      markDisputedScores({
        plateId: lastSelectedWell?.plateID,
        wellNumber: lastSelectedWell.wellNum,
        disputedScoreGroupsIds: disputedScoresIds,
      }),
    );
  };

  const tabComponents: ITabItem[] = useMemo(
    () => [
      {
        title: 'Score Group',
        eventKey: 'scoreGroup',
        content: (
          <DefaultScores
            allScoresOptionsList={allScoresOptionsList}
            selectedWellDetails={selectedWellDetails}
            selectedWellsScores={scoresOfSelectedWells}
            applyScoring={applyScoring}
            imageBatchId={imageBatchId}
            dropNumber={dropNumber}
            cpId={cpId}
          />
        ),
      },
      {
        title: 'Auto Score',
        eventKey: 'autoScore',
        content: (
          <MarcoScore
            handleOnMarkDisputedScore={handleOnMarkDisputedScore}
            imageBatchId={imageBatchId}
            dropNumber={dropNumber}
            selectedWellsScores={scoresOfSelectedWells}
          />
        ),
      },
    ],
    [scoresOfSelectedWells, dropNumber, imageBatchId, cpId],
  );

  return (
    <div
      id="exppanel-scorespanel-wrappeer"
      className="container-fluid p-0 border"
      style={styles.container}
    >
      <div id="exppanel-scorespanel-row" className="row">
        <div id="exppanel-scorespanel-col" className="col-md-12">
          <div
            id="scorepanel-header"
            className="flex flex-row w-full min-h-[7vh] bg-[#F5F5F5] items-center pl-[1.5%]"
          >
            <div
              id="scorepanel-header-left-title"
              className="font-semibold text-ellipsis overflow-hidden my-auto"
              title={'Score'}
            >
              Score
            </div>
          </div>
          <RMTabs
            id={'exppanel-scorespanel-scoretab'}
            tabItems={tabComponents}
            defaultActiveKey={'scoreGroup'}
          />
        </div>
      </div>
    </div>
  );
}
//if we don't use memo, the component remount repeatedly
export default React.memo(ScoresPanel);

const styles: IStyle = {
  container: {
    height: '800px',
  },
};
